import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const employeeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployees: builder.query<
      CommonResponse,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.getEmployee}?search=${search}&pageNumber=${page} `,
        method: "GET",
      }),
    }),

    getEmployeeDetails: builder.query<
      CommonResponse,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.employeeDetails}/${id}`,
        method: "GET",
      }),
    }),

    addEmployee: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addEmployee,
        method: "POST",
        body,
      }),
    }),

    changeEmployeeStatus: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.employeeStatus,
        method: "POST",
        body,
      }),
    }),

    updateEmployee: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.updateEmployee,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetEmployeesQuery,
  useAddEmployeeMutation,
  useChangeEmployeeStatusMutation,
  useLazyGetEmployeeDetailsQuery,
  useUpdateEmployeeMutation,
} = employeeApi;
